import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import type { PoliciesPageProps } from "@/pages/GovernancePage/components/pages/PoliciesPage"

export const DescriptionPolicies = (props: PoliciesPageProps) => {
  const { type } = props
  const { t } = useTranslation("translation", {
    keyPrefix: `governance.policies.${type}`
  })

  // Only CI policies have a third_line_note
  const hasThirdLineNote = type === "ci"

  return (
    <Flex vertical flex={1} data-testid="description-policies">
      <Text type="secondary">{t("first_line_note")}</Text>
      <Text type="secondary">{t("second_line_note")}</Text>
      {hasThirdLineNote && <Text type="secondary">{t("third_line_note")}</Text>}
    </Flex>
  )
}
